export const EVENT_BUNDLE_VARIATION_CLICKED = "product-bundle-variation-clicked";